import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE, INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { withAnalytics } from '@atlaskit/editor-common/editor-analytics';
import { getPluginState as getInlineSuggestionPluginState } from '../plugin-factory';
import { insertInlineSuggestion, clearSuggestion } from './commands';
var getInlineSuggestionDetails = function getInlineSuggestionDetails(state) {
  var pluginState = getInlineSuggestionPluginState(state);
  var inlineSuggestion = pluginState.inlineSuggestion,
    locale = pluginState.locale,
    inlineSuggestionSessionId = pluginState.inlineSuggestionSessionId;
  return {
    matchedFormat: (inlineSuggestion === null || inlineSuggestion === void 0 ? void 0 : inlineSuggestion.type) === 'date' ? inlineSuggestion === null || inlineSuggestion === void 0 ? void 0 : inlineSuggestion.metadata.matchedFormat : undefined,
    suggestionType: inlineSuggestion === null || inlineSuggestion === void 0 ? void 0 : inlineSuggestion.type,
    locale: locale,
    inlineSuggestionSessionId: inlineSuggestionSessionId
  };
};
var getInlineSuggestionInsertPayload = function getInlineSuggestionInsertPayload(_ref) {
  var state = _ref.state,
    triggeredFrom = _ref.triggeredFrom;
  var _getInlineSuggestionD = getInlineSuggestionDetails(state),
    matchedFormat = _getInlineSuggestionD.matchedFormat,
    suggestionType = _getInlineSuggestionD.suggestionType,
    locale = _getInlineSuggestionD.locale,
    inlineSuggestionSessionId = _getInlineSuggestionD.inlineSuggestionSessionId;
  return {
    eventType: EVENT_TYPE.TRACK,
    action: ACTION.SUGGESTION_INSERTED,
    actionSubject: ACTION_SUBJECT.EDITOR_PLUGIN_AI,
    actionSubjectId: ACTION_SUBJECT_ID.AI_INLINE_SUGGESTION,
    attributes: {
      locale: locale,
      suggestionType: suggestionType,
      triggeredFrom: triggeredFrom,
      matchedFormat: matchedFormat,
      inlineSuggestionSessionId: inlineSuggestionSessionId
    }
  };
};
export var insertInlineSuggestionWithAnalytics = function insertInlineSuggestionWithAnalytics(analyticsApi) {
  return function (triggeredFrom) {
    /* This is a "curry" function to fire 2 events
     * The reason we fire 2 so that we can track the suggestion inserted event
     * and also the document event (wider editor analytics) for the date suggestion
     */
    var insertInlineSuggestionWithAnalyticsCommand = withAnalytics(analyticsApi, function (state) {
      return getInlineSuggestionInsertPayload({
        state: state,
        triggeredFrom: triggeredFrom
      });
    })(insertInlineSuggestion());
    return withAnalytics(analyticsApi, function () {
      return {
        action: ACTION.INSERTED,
        actionSubject: ACTION_SUBJECT.DOCUMENT,
        actionSubjectId: ACTION_SUBJECT_ID.DATE,
        eventType: EVENT_TYPE.TRACK,
        attributes: {
          inputMethod: INPUT_METHOD.INLINE_SUGGESTION_FLOATING_TB
        }
      };
    })(insertInlineSuggestionWithAnalyticsCommand);
  };
};
export var clearSuggestionWithAnalytics = function clearSuggestionWithAnalytics(analyticsApi) {
  return function (triggeredFrom) {
    return withAnalytics(analyticsApi, function (state) {
      var _getInlineSuggestionD2 = getInlineSuggestionDetails(state),
        matchedFormat = _getInlineSuggestionD2.matchedFormat,
        suggestionType = _getInlineSuggestionD2.suggestionType,
        locale = _getInlineSuggestionD2.locale,
        inlineSuggestionSessionId = _getInlineSuggestionD2.inlineSuggestionSessionId;
      return {
        eventType: EVENT_TYPE.TRACK,
        action: ACTION.SUGGESTION_DISMISSED,
        actionSubject: ACTION_SUBJECT.EDITOR_PLUGIN_AI,
        actionSubjectId: ACTION_SUBJECT_ID.AI_INLINE_SUGGESTION,
        attributes: {
          locale: locale,
          suggestionType: suggestionType,
          triggeredFrom: triggeredFrom,
          matchedFormat: matchedFormat,
          inlineSuggestionSessionId: inlineSuggestionSessionId
        }
      };
    })(clearSuggestion());
  };
};
var getNewSuggestionAnalytics = function getNewSuggestionAnalytics() {
  return function (_ref2) {
    var analyticsApi = _ref2.analyticsApi,
      state = _ref2.state;
    var _getInlineSuggestionD3 = getInlineSuggestionDetails(state),
      matchedFormat = _getInlineSuggestionD3.matchedFormat,
      suggestionType = _getInlineSuggestionD3.suggestionType,
      locale = _getInlineSuggestionD3.locale,
      inlineSuggestionSessionId = _getInlineSuggestionD3.inlineSuggestionSessionId;
    analyticsApi === null || analyticsApi === void 0 || analyticsApi.fireAnalyticsEvent({
      eventType: EVENT_TYPE.TRACK,
      action: ACTION.SUGGESTION_VIEWED,
      actionSubject: ACTION_SUBJECT.EDITOR_PLUGIN_AI,
      actionSubjectId: ACTION_SUBJECT_ID.AI_INLINE_SUGGESTION,
      attributes: {
        matchedFormat: matchedFormat,
        suggestionType: suggestionType,
        locale: locale,
        inlineSuggestionSessionId: inlineSuggestionSessionId
      }
    });
  };
};
export var fireNewSuggestionAnalytics = getNewSuggestionAnalytics();